import { z } from "zod";

/**
 * Staff session identity exposed to the dashboard after Better Auth
 * `GET /auth/get-session`. `restaurantId` is intentionally absent.
 */
export const StaffSessionSchema = z.object({
  userId: z.string().min(1),
  role: z.enum(["RESTAURANT", "ADMIN"]),
  email: z.string().min(1),
  name: z.string().min(1),
});

export type StaffSessionView = z.infer<typeof StaffSessionSchema>;

export const BetterAuthUserSchema = z.object({
  id: z.string().min(1),
  email: z.string().min(1),
  name: z.string().min(1),
  role: z.enum(["RESTAURANT", "ADMIN"]),
});

export const BetterAuthGetSessionSchema = z
  .object({
    session: z
      .object({
        id: z.string().min(1),
        userId: z.string().min(1),
      })
      .nullable()
      .optional(),
    user: BetterAuthUserSchema.nullable().optional(),
  })
  .nullable();

export type BetterAuthGetSession = z.infer<typeof BetterAuthGetSessionSchema>;
